import { useState } from "react";
import { FileDown, Upload, X } from "lucide-react";
import { http, formatApiError, downloadUrl } from "../../lib/api";
import { toast } from "../../lib/notify";
import UploadResult from "../projects/UploadResult";

// Excel'den toplu cari: şablonu indir → doldur → yükle; hatalı satırlar listelenir ve Excel olarak indirilebilir
export default function CariBulkUpload({ onSaved, onClose }) {
  const [file, setFile] = useState(null);
  const [lastFile, setLastFile] = useState(null);
  const [updateExisting, setUpdateExisting] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const upload = async () => {
    if (!file) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("update_existing", updateExisting ? "true" : "false");
      const { data } = await http.post("/caris/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(data); setLastFile(file); setFile(null);
      toast.success(`${data.created} cari oluşturuldu${data.updated ? `, ${data.updated} güncellendi` : ""}${data.errors.length ? `, ${data.errors.length} satır hatalı` : ""}`);
      if (data.created || data.updated) onSaved?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-lg border-2 border-amber-300 bg-amber-50/50 p-3 space-y-2" data-testid="cari-bulk-panel">
      <div className="flex items-center gap-2 flex-wrap">
        <Upload className="w-4 h-4 text-amber-700" />
        <span className="text-xs font-bold text-amber-900">Excel'den Toplu Cari</span>
        <span className="text-[11px] text-amber-800">— Şablonu indirin, carileri yazın, yükleyin. Cari Adı zorunlu; aynı ada sahip kayıt varsa atlanır.</span>
        <button type="button" onClick={onClose} className="ml-auto p-1 rounded hover:bg-amber-100" data-testid="cari-bulk-close"><X className="w-4 h-4" /></button>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <a href={downloadUrl("/caris/template")} target="_blank" rel="noreferrer" data-testid="cari-bulk-template"
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-amber-700 text-amber-900 bg-white text-xs font-semibold hover:bg-amber-100">
          <FileDown className="w-3.5 h-3.5" /> Excel Şablonu
        </a>
        <input type="file" accept=".xlsx,.xlsm" data-testid="cari-bulk-file" onChange={(e) => { setFile(e.target.files?.[0] || null); setResult(null); }} className="text-[11px] text-slate-600 max-w-[16rem]" />
        <label className="inline-flex items-center gap-1.5 text-xs text-slate-700 cursor-pointer" data-testid="cari-bulk-update-label">
          <input type="checkbox" checked={updateExisting} onChange={(e) => setUpdateExisting(e.target.checked)} data-testid="cari-bulk-update" /> Mevcut cariyi güncelle (aynı ad)
        </label>
        <button type="button" onClick={upload} disabled={!file || busy} data-testid="cari-bulk-upload"
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md bg-amber-700 text-white text-xs font-semibold hover:bg-amber-800 disabled:opacity-50">
          <Upload className="w-3.5 h-3.5" /> {busy ? "Yükleniyor…" : "Yükle"}
        </button>
      </div>
      {result && (
        <UploadResult testid="cari-bulk-result" summary={`${result.total_rows} satır okundu · ${result.created} oluşturuldu · ${result.updated} güncellendi · ${result.skipped} atlandı`}
          errors={result.errors} file={lastFile} name="Cari Yükleme" />
      )}
    </div>
  );
}
